import React, { memo } from "react";
import { Handle, Position } from "reactflow";
import type { NodeProps } from "reactflow";
import "../../styles/components/CustomNode.css";

interface TriggerNodeProps extends NodeProps {
  data: any;
}

const TriggerNode: React.FC<TriggerNodeProps> = ({ data, selected }) => {
  return (
    <div className={`custom-node node-trigger ${selected ? "selected" : ""}`}>
      <div className="node-header">
        <div className="node-header-icon">{data.icon || "⚡"}</div>
        <div className="node-header-title">{data.label || "Trigger"}</div>
      </div>

      <div className="node-body">
        {data?.nodeKey && (
          <div className="node-field">
            <div className="node-field-label">Type:</div>
            <div className="node-field-value">{data.nodeKey}</div>
          </div>
        )}
        {data.config?.module && (
          <div className="node-field">
            <div className="node-field-label">Module:</div>
            <div className="node-field-value">{data.config.module}</div>
          </div>
        )}
        {data.config?.event && (
          <div className="node-field">
            <div className="node-field-label">Event:</div>
            <div className="node-field-value">{data.config.event}</div>
          </div>
        )}
      </div>

      {/* Trigger nodes only have output (source) handles */}
      <Handle
        type="source"
        position={Position.Right}
        className="node-handle"
        style={{ background: data.color || "#3b82f6" }}
      />
    </div>
  );
};

export default memo(TriggerNode);
